module.exports = __webpack_public_path__ + "img/weixin.9bf38435.png";